import { useEffect, useState } from 'react';
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { getUserDetails } from '../../utils';

const ROLE_EDIFIER = 'COACH';
const ROLE_SITE_LEADER = 'SITE-LEADER';

const SwitchRole = () => {
  const userDetails = getUserDetails();
  const [currentRole, setCurrentRole] = useState(userDetails?.role ?? ROLE_EDIFIER);
  const [isSwitch, setIsSwitch] = useState(false);

  useEffect(() => {
    const role = userDetails?.role;
    if (role === ROLE_EDIFIER || role === ROLE_SITE_LEADER) {
      setCurrentRole(role);
    }
  }, [userDetails?.role]);

  useEffect(() => {
    const hasBothRoles =
      userDetails?.totalRoles?.length === 2 &&
      userDetails?.totalRoles?.includes(ROLE_EDIFIER) &&
      userDetails?.totalRoles?.includes(ROLE_SITE_LEADER);
    if (hasBothRoles) {
      setIsSwitch(true);
    }
  }, [userDetails?.totalRoles]);

  const handleRoleChange = (event, newRole) => {
    if (newRole == null) return; // exclusive toggle: null when clicking active option
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    user.role = newRole;
    localStorage.setItem('user', JSON.stringify(user));
    setCurrentRole(newRole);
    window.location.replace('/dashboard/app');
  };

  if (!isSwitch) return null;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <ToggleButtonGroup
        value={currentRole}
        exclusive
        onChange={handleRoleChange}
        aria-label="Switch role"
        size="small"
        sx={{
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          p: 0.25,
          '& .MuiToggleButtonGroup-grouped': {
            border: 0,
            borderRadius: 1.5,
            px: 1.5,
            py: 0.75,
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.8125rem',
            '&.Mui-selected': {
              bgcolor: 'primary.main',
              color: 'primary.contrastText',
              '&:hover': {
                bgcolor: 'primary.dark',
              },
            },
            '&:not(.Mui-selected)': {
              color: 'text.secondary',
              '&:hover': {
                bgcolor: 'action.hover',
                color: 'text.primary',
              },
            },
          },
        }}
      >
        <ToggleButton value={ROLE_EDIFIER} aria-label="View as Edifier">
          <PersonIcon sx={{ fontSize: 18, mr: 0.5 }} />
          <Typography component="span" variant="body2" sx={{ fontWeight: 'inherit' }}>
            Edifier
          </Typography>
        </ToggleButton>
        <ToggleButton value={ROLE_SITE_LEADER} aria-label="View as Site Leader">
          <AdminPanelSettingsIcon sx={{ fontSize: 18, mr: 0.5 }} />
          <Typography component="span" variant="body2" sx={{ fontWeight: 'inherit' }}>
            Site Leader
          </Typography>
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default SwitchRole;
